module.exports = __webpack_public_path__ + "img/pass.a725f326.png";